// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://epevmahshnfhrzfufern.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVwZXZtYWhzaG5maHJ6ZnVmZXJuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzg2MzI5ODIsImV4cCI6MjA1NDIwODk4Mn0.Zj2GiP7FoObLBzs3p5ri2_Sf8AVHSox-WYm4pXgUXmo";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);